export default "__VITE_ASSET__9c484522__"